export enum DocumentType {
  Payslip = 'payslip',
  ExpenseNote = 'expenseNote',
  HealthInsuranceCertificate = 'healthInsuranceCertificate',
  TaxCertificate = 'taxCertificate',
}
